module.exports = __webpack_public_path__ + "img/27.70a28067.png";